import React from "react";

export const MessageBotIcon = ({ sizeContainer, fill, size }) => {
  return (
    <div
      style={{
        width: sizeContainer ? sizeContainer : "64px",
        height: sizeContainer ? sizeContainer : "64px",
        background: "#3E8FCB",
        borderRadius: "100px",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        fill="none"
        viewBox="0 0 640 512"
      >
        <path
          fill={fill}
          d="M608 159.1c-18.85 0-25.44 13.31-27.03 16H544V80C544 35.82 508.2 0 464 0h-288C131.8 0 96 35.82 96 80v95.1H59.03C57.44 173.3 50.85 159.1 32 159.1c-17.06 0-32 13.72-32 32c0 18.3 14.97 31.1 32 31.1c18.85 0 25.44-13.3 27.03-15.1H96v127.1c0 44.18 35.82 80 80 80L224 415.1v83.99C224 503.3 226.7 512 236 512c2.521 0 4.998-.8086 7.096-2.328L368 415.1l96 .0059c44.18 0 80-35.82 80-80V207.1h36.98C582.6 210.7 589.2 223.1 608 223.1c17.06 0 32-13.72 32-31.1C640 173.7 625.1 159.1 608 159.1zM480 256c0 17.67-14.33 32-32 32H192C174.3 288 160 273.7 160 256V128c0-17.67 14.33-32 32-32h256c17.67 0 32 14.33 32 32V256zM224 159.1c-17.67 0-32 14.33-32 32c0 17.67 14.33 32 32 32s32-14.33 32-32C256 174.3 241.7 159.1 224 159.1zM416 159.1c-17.67 0-32 14.33-32 32c0 17.67 14.33 32 32 32s32-14.33 32-32C448 174.3 433.7 159.1 416 159.1z"
        />
      </svg>
    </div>
  );
};
